import angular from 'angular';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';

class CallbacksService {
    constructor(jsonService, dataService, windowDimensionsService, config) {
        this.jsonService = jsonService;
        this.dataService = dataService;
        this.windowDimensionsService = windowDimensionsService;
        this.config = config;
    }

    updateDrawingData() {
        this.lastCopy = cloneDeep(this.jsonObject);
        this.updateFunction(this.lastCopy);
    }

    mullionsMove(response) {
        this.jsonObject = cloneDeep(this.jsonService.jsonObject);
        const divider = this.getDivider(response.mullion, response.sash);
        divider.position = response.position;
        this.mullionAdiacentsMove(response.mullion, response.sash, response.difference);

        this.updateDrawingData();
    }

    mullionAdiacentsMove(mullion, sash, difference) {
        if (sash) {
            this.moveIntSash(mullion, sash, difference);
        } else {
            this.moveSash(mullion, difference);
        }
    }

    moveSash(mullion, difference, sashes = this.jsonObject.sashes) {
        if (mullion.direction === 'horizontal') {
            this.moveHorizontalSash(sashes, mullion, difference);
            this.moveHorizontalDividers(sashes, mullion, difference);
        } else {
            this.moveVerticalSash(sashes, mullion, difference);
            this.moveVerticalDividers(sashes, mullion, difference);
        }
    }


    moveIntSash(mullion, sash, difference) {
        this.moveSash(mullion, difference, sash);
    }

    moveVerticalDividers(sashes, mullion, difference) {
        forEach(mullion.adjacentDividers.left, (el) => {
            const adjacentDivider = this.getDivider({ id: el }, sashes);
            adjacentDivider.length -= difference;
        });

        forEach(mullion.adjacentDividers.right, (el) => {
            const adjacentDivider = this.getDivider({ id: el }, sashes);
            adjacentDivider.length += difference;
        });
    }

    moveHorizontalDividers(sashes, mullion, difference) {
        forEach(mullion.adjacentDividers.top, (el) => {
            const adjacentDivider = this.getDivider({ id: el }, sashes);
            adjacentDivider.length -= difference;
        });

        forEach(mullion.adjacentDividers.bottom, (el) => {
            const adjacentDivider = this.getDivider({ id: el }, sashes);
            adjacentDivider.length += difference;
        });
    }

    moveVerticalSash(sashes, mullion, difference) {
        forEach(mullion.adjacentSashes.left, (el) => {
            const currentSash = this.getSash(el, sashes);
            let multiplier = 1;
            forEach(currentSash.intDividers, (el1) => {
                if (el1.direction === 'vertical') {
                    multiplier++;
                }
            });
            currentSash.width -= difference;
            const displacement = difference / multiplier;

            forEach(currentSash.intSashes, (el1) => {
                const currentIntSash = el1;
                currentIntSash.width -= displacement;
                currentIntSash.x -= currentIntSash.x ? displacement : 0;
            });

            forEach(currentSash.intDividers, (el1) => {
                const currentIntSash = el1;
                if (currentIntSash.direction === 'vertical') {
                    currentIntSash.position -= displacement;
                } else {
                    currentIntSash.length -= displacement;
                }
            });
        });

        forEach(mullion.adjacentSashes.right, (el) => {
            const currentSash = this.getSash(el, sashes);
            let multiplier = 1;
            forEach(currentSash.intDividers, (el1) => {
                if (el1.direction === 'vertical') {
                    multiplier++;
                }
            });
            const displacement = difference / multiplier;

            currentSash.width += difference;
            currentSash.x = currentSash.x ? currentSash.x - difference : 0;

            forEach(currentSash.intSashes, (el1) => {
                const currentIntSash = el1;
                currentIntSash.width += displacement;
                currentIntSash.x += currentIntSash.x ? displacement : 0;
                forEach(el1.mullion, (el2) => {
                    forEach(el2.vertical, (el3) => {
                        const currentMuntin = el3;
                        currentMuntin.position += displacement;
                    });
                    forEach(el2.horizontal, (el3) => {
                        const currentMuntin = el3;
                        currentMuntin.length += displacement / (el2.vertical + 1);
                    });
                });
            });

            forEach(currentSash.intDividers, (el1) => {
                const currentIntSash = el1;
                if (currentIntSash.direction === 'vertical') {
                    currentIntSash.position += displacement;
                } else {
                    currentIntSash.length += displacement;
                }
            });
        });
    }

    moveHorizontalSash(sashes, mullion, difference) {
        forEach(mullion.adjacentSashes.top, (el) => {
            const currentSash = this.getSash(el, sashes);
            currentSash.height -= difference;

            forEach(currentSash.intSashes, (el1) => {
                const currentIntSash = el1;
                currentIntSash.height = currentSash.height;
            });

            forEach(currentSash.intDividers, (el1) => {
                const currentIntSash = el1;
                currentIntSash.length = currentSash.height;
            });
        });

        forEach(mullion.adjacentSashes.bottom, (el) => {
            const currentSash = this.getSash(el, sashes);
            currentSash.height += difference;
            currentSash.y = currentSash.y ? currentSash.y - difference : 0;

            forEach(currentSash.intSashes, (el1) => {
                const currentIntSash = el1;
                currentIntSash.height = currentSash.height;
            });

            forEach(currentSash.intDividers, (el1) => {
                const currentIntSash = el1;
                currentIntSash.length = currentSash.height;
            });
        });
    }


    registerUpdateFunction(registerFunction) {
        this.updateFunction = registerFunction;
    }

    getDivider(mullion, sash) {
        let divider = find(this.jsonObject.dividers, el => el.id === mullion.id);

        if (!divider) {
            divider = this.getIntDivider(mullion, sash);
        }

        return divider;
    }

    getSash(id, sash = this.jsonObject.sashes) {
        const currentSash = find(sash, el => el.id === id);
        if (currentSash) {
            return currentSash;
        }
        const parentSash = this.getSash(sash.id);
        return find(parentSash.intSashes, el => el.id === id);
    }

    getIntDivider(mullion, sash) {
        const parentSash = this.getSash(sash.id);
        const intDivider = find(parentSash.intDividers, el => el.id === mullion.id);

        return intDivider;
    }

    muntinsMove(response) {
        this.jsonObject = cloneDeep(this.jsonService.jsonObject);
        const intSash = this.getIntSash(response.sash);
        const muntin = this.getMuntin(intSash, response.muntin);
        muntin.positionInSash -= response.difference;

        this.updateDrawingData();
    }

    getIntSash(sash) {
        if (angular.isDefined(sash.parentId)) {
            const currentSash = this.getSash(sash.parentId);
            const intSash = this.getSash(sash.id, currentSash);
            return intSash;
        }
        return this.getSash(sash.id);
    }

    getMullionCondition(mullion, sashes) {
        let isMovingBar = true;
        forEach(mullion.adjacentSashes, (el) => {
            forEach(el, (el1) => {
                if (!sashes) {
                    const sash = this.getSash(el1, this.jsonService.sashesService.getSashesJson());
                    if (sash.type.type !== 'F' && sash.type.type !== 'K' && sash.type.type !== 'D') {
                        isMovingBar = false;
                    }
                }
            });
        });

        return isMovingBar;
    }

    getMuntin(sash, muntin) {
        return find(sash.muntins[muntin.direction], el => el.id === muntin.id);
    }

    getButtonsOptions(movableMullions, drawVisibleSide = 'inner') {
        const config = {
            muntins: {
                buttons: [{
                    condition: response => angular.isDefined(response.muntin.lengthInSash),
                    onMove: (response) => { this.muntinsMove(response); },
                    positions: ['rect'],
                }],
            },
            mullion: {
                minPosition: 400,
                buttons: [{
                    condition: response => this.getMullionCondition(response.mullion, response.sash),
                    positions: ['rect'],
                    onMove: (response) => { this.mullionsMove(response); },
                }],
            },
            base: {
                indexes: true,
            },
            indexes: true,
        };

        if (!movableMullions || this.windowDimensionsService.blockMullions) {
            config.muntins.buttons = [];
            config.mullion.buttons = [];
        }

        config.base = { side: drawVisibleSide };

        return config;
    }
}

CallbacksService.$inject = ['jsonService', 'dataService', 'windowDimensionsService', 'config'];

export default angular.module('callbacksService', [])
    .service('callbacksService', CallbacksService)
    .name;